<template>
	<div class="nav-search mr-auto">
		<div class="form-group">
			<input class="form-control mr-sm-3" v-model="query" type="search" :placeholder="'nav.search' | trans" aria-label="'nav.search' | trans" @focus="focus" @blur="blur">
			<i class="fa fa-times-circle" v-if="query.length > 0" @click.prevent="clear"></i>
		</div>

		<!-- Results -->
		<div class="results" v-show="results.length > 0">
			<div class="container-fluid">
				<strong class="d-block">
					{{ meta.total }}
					Treffer
				</strong>
			</div>

			<div class="container-fluid">
				<div class="list-group list-group-flush w-100">
					<a :href="tripRoute.replace('TRIP', item.permalink)" class="list-group-item list-group-item-action" v-for="item in results" target="_blank">
						
						<div class="media">
							<img :src="$cdn.default + 'deals/' + item.guid + '/' + item.image + '?width=50&height=50'" :srcset="$cdn.default + 'deals/' + item.guid + '/' + item.image + '?width=50&height=50 1x, ' + $cdn.default + 'deals/' + item.guid + '/' + item.image + '?width=100&height=100 2x'" class="rounded mr-3">
							<div class="media-body">
								<strong class="d-block">
									{{ item.short_title }}
								</strong>
								<small class="d-block" v-if="item.subtitle">
									{{ item.subtitle }}
								</small>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>

		<!-- Backdrop -->
		<div class="backdrop" v-show="active" @click.prevent="close()"></div>
	</div>
</template>

<script>
export default {
	props: [
		'searchEndpoint',
		'tripRoute'
	],
	data: function() {
		return {
			query: '',
			active: false,
			results: [],
			meta: {},
			isError: false
		}
	},
	mounted: function() {
		// Esc
		document.body.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				this.close();
			}
		});
	},
	watch: {
		query: function() {
			var self = this;

			if (this.query.length > 0) {
				axios.post(this.searchEndpoint, {
					query: this.query
				}).then(function (response) {
					self.results = response.data.data;
					self.meta = response.data.meta;
				}).catch(function (error) {
					self.isError = true;
				});
			} else {
				this.results = [];
				this.meta = {};
			}
		}
	},
	computed: {},
	methods: {
		clear: function() {
			this.query = '';
			$('div.nav-search input[type=search]').focus();
		},
		focus: function() {
			// Set backdrop top + results top
			var navHeight = $('nav.top-nav').outerHeight() + $('nav.top-nav').offset().top;
			$('div.nav-search div.backdrop').css('top', navHeight + 'px');
			$('div.nav-search div.results').css('top', navHeight + 'px');

			// Disable body scroll
			var targetElement = document.querySelector("div.nav-search");
			disableBodyScroll(targetElement);

			this.active = true;
		},
		close: function() {
			// Enable body scroll
			var targetElement = document.querySelector("div.nav-search");
			enableBodyScroll(targetElement);

			this.query = '';
			this.results = [];
			this.meta = {};
			this.active = false;
			$('div.nav-search input[type=search]').blur();
		},
		blur: function() {
			if (this.query.length === 0) {
				this.close();
			}
		}
	}
}
</script>